import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useWorkspacePayments } from '@/hooks/api/2330_workspace_payments';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import moment from 'moment';
import { useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';

export const WorkspacePayments = () => {
  const { _w_, me } = useCurrentWorkspace();

  if (me?.admin) {
    return <_WorkspacePayments />;
  } else {
    return <Navigate replace to={'/workspaces'} />;
  }
};

export const _WorkspacePayments = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('お支払履歴'), []);
  useEffect(() => setBreadcrumbs([{ label: `ワークスペース設定`, path: `/w/${_w_!.identifier}/setting` }]), []);

  const navigate = useNavigate();
  const { _w_, me } = useCurrentWorkspace();
  const { data } = useWorkspacePayments({ identifier: _w_!.identifier, page: 1, per: 1000 });

  if (data == null) return <></>;

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'basic'} />
      </div>

      <div className="row">
        <div className="col-12 col-lg-9 mx-auto">
          <div className="card mb-4">
            <div className="card-header d-flex align-items-center">
              <div className="col-md-8">
                <h5 className="mb-0">お支払履歴</h5>
              </div>
              <div className="col-md-4 d-flex justify-content-end">
                <Link className="btn btn-outline-secondary" to={`/w/${_w_!.identifier}/setting`}>
                  戻る
                </Link>
              </div>
            </div>
            <div className="card-body pt-0">
              {data.workspace_payments.length == 0 ? (
                <p className="card-description text-sm">お支払履歴がありません。</p>
              ) : (
                <div className="table-responsive">
                  <table className="table align-items-center">
                    <thead>
                      <tr>
                        <th
                          className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                          style={{ width: 200 }}
                        >
                          決済日時
                        </th>
                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                          適用プラン
                        </th>
                        <th
                          className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end"
                          style={{ width: 200 }}
                        >
                          お支払金額
                        </th>
                        <th
                          className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end"
                          style={{ width: 50 }}
                        >
                          請求書
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.workspace_payments.map((d) => (
                        <tr key={`wp-${d.id}`}>
                          <td className="text-secondary text-xs font-weight-bold text-wrap">
                            {moment(d.paid_at).format('YYYY/MM/DD HH:mm')}
                          </td>
                          <td className="text-secondary text-xs font-weight-bold text-wrap">{d.description}</td>
                          <td className="text-secondary text-xs font-weight-bold text-wrap text-end">
                            ¥{(d.amount + d.tax).toLocaleString()}
                          </td>
                          <td className="text-secondary text-xs font-weight-bold text-wrap text-end">
                            <a
                              href={d.file_url!}
                              target="_blank"
                              className="d-flex align-items-center justify-content-between"
                              rel={'noreferrer'}
                            >
                              <div className="d-flex align-items-center">
                                <div className="icon icon-sm bg-dark d-flex border-radius-md align-items-center justify-content-center flex-shrink-0">
                                  <i className="fas fa-download text-white"></i>
                                </div>
                              </div>
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
